export const SubscriptionChangeSteps = {
  PACKAGE_SELECTION: 1,
  OVERVIEW: 2,
};

export const SubscriptionActiveFormOptions = {
  NOW: 'now',
  NEXT_RENEWAL: 'nextRenewal',
};

export const SPOTIFY_LOGO_S3_URL =
  'https://subrite.s3.eu-north-1.amazonaws.com/misc/podcast/spotify-color-svgrepo-com.svg';

export const APPLE_PODCASTS_LOGO_S3_URL =
  'https://subrite.s3.eu-north-1.amazonaws.com/misc/podcast/applepodcast.png';

export const POCKET_CASTS_LOGO_S3_URL =
  'https://subrite.s3.eu-north-1.amazonaws.com/misc/podcast/Pocket_Casts_icon.svg';

export const ANDROID_LOGO_S3_URL =
  'https://subrite.s3.eu-north-1.amazonaws.com/misc/podcast/Android_robot.svg';

export const OVERCAST_LOGO_S3_URL =
  'https://subrite.s3.eu-north-1.amazonaws.com/misc/podcast/overcast.png';

export const SUBSCRIPTIONLIST_STATUS_COLORS = {
  active: 'bg-green-500',
  inactive: 'bg-dividerGrey',
  pending: 'bg-yellow-500',
  paused: 'bg-blue-500',
  stopped: 'bg-rose-500',
  waiting: 'bg-yellow-300',
  expired: 'bg-gray-500',
  waiting_for_activation: 'bg-yellow-300',
};

export const REQUIRED_TENANT_SPECIFIC_CTA_COLOR =
  'bg-[var(--themePrimaryButtonColor)] text-[var(--themePrimaryButtonTextColor)] hover:bg-[var(--themePrimaryHoverColor)]';

export const DEFAULT_CTA_COLOR = 'bg-gray-100 text-black hover:bg-gray-200';

export const MEMBER_PROFILE_TAG = 'memberProfile';

export const MEMBER_SUBSCRIPTIONS_TAG = 'memberSubscriptions';

export const MEMBER_SUBSCRIPTIONS_PRODUCT_SEAT_TAG = 'memberSubscriptionsProductSeat';

export const MEMBER_SUBSCRIPTIONS_PRODUCT_TAG = 'memberSubscriptionsProduct';

export const MEMBER_MISSING_INFO_TAG = 'memberMissingInfo';

export enum MyPageSubriteStandardCardTarget {
  invoicesCardTarget = '/account/invoices',
  consentCardTarget = '/account/consent',
  ordersCardTarget = '/account/orders',
  subscriptionsCardTarget = '/account/subscriptions',
  podcastsCardTarget = '/account/podcasts',
}

export const MYPAGE_DEFAULT_ROUTE = '/account';

export const SUPPORTED_LANGUAGES = ['en', 'no'];
